import { Initializer } from 'common/types/initializers';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';
import type { RescheduleFeedbackModalProps } from 'reconnect-types/moduleFederation';

export const RescheduleFeedbackModalInitializer = ({
  onDismiss,
  onSubmit,
  ...otherProps
}: RescheduleFeedbackModalProps): Initializer => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="RescheduleFeedbackModal"
        props={{
          onDismiss: () => {
            onDismiss?.();
            destroy();
          },
          onSubmit: (reason: string, rescheduleOtherAppointments: boolean) => {
            onSubmit?.(reason, rescheduleOtherAppointments);
            destroy();
          },
          ...otherProps,
        }}
      />,
      container,
    );
  };

  return { destroy, render };
};
